import React, { Component } from 'react';
import { BrowserView, MobileView, isBrowser } from 'react-device-detect';
import OwlCarousel from 'react-owl-carousel2';
import animations from './animations';
import Heading from "../../elements/Heading";

class Partners extends Component {

    constructor(props) {
        super(props);

        this.sceneController = null;
        this.state = {
            partners: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                partners: this.props.data.partners
            }, () => {
                this.sceneController = animations.initialise(this);
            });
        }
    }

    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }

    setLogos() {
        if (isBrowser) {
            const oddNumbers = this.state.partners.filter((value, key) => key % 2 !== 0);
            const evenNumbers = this.state.partners.filter((value, key) => key % 2 === 0);

            return oddNumbers.map((partner, key) => {
                return (
                    <div key={key} className="logo-col">
                        <img src={partner.image} alt={partner.title} />
                        <img src={evenNumbers[key].image} alt={evenNumbers[key].title} />
                    </div>
                );
            });
        } else {
        	// Hack: Remove the first entry from array on mobile since we duplicated Telstra
        	this.state.partners.splice(0, 1);
            return this.state.partners.map((partner, key) => {
                return (
                    <div key={key} className="logo-col">
                        <img src={partner.image} alt={partner.title} />
                    </div>
                );
            });
        }
    }

    render() {
        let Logos = this.setLogos();
        const options = {
            items: 2,
            loop: true,
            autoplay: true,
            dots: false,
            autoHeight: false
        };

        return (
            <section className="our-partners">
                <div className="mask" />
                <div className="panel">
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2 col-xs-12 text-sm-center text-xs-center">
                            <Heading
                                title={this.props.data.title}
                                subTitle={this.props.data.subTitle}
                                setSubTitleRef={this.setSubTitleRef}
                            />
                            <p>{this.props.data.leadCopy}</p>
                        </div>
                    </div>
                </div>
                <div className="logos">
                    <div className="row logos-wrapper">
                        <div className="col-xs-12">
                            <BrowserView>
                                {Logos}
                            </BrowserView>
                            <MobileView>
                                {this.state.partners.length > 0 ?
                                    <OwlCarousel options={options}>
                                        {Logos}
                                    </OwlCarousel>
                                    : ''}
                            </MobileView>
                        </div>
                    </div>
                </div>
                <div className="about-trigger" />
            </section>
        );
    }
    
}

export default Partners;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Partners/Partners.js